import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ReplacePipe } from '../../pipe/replace.pipe';

interface DocBlock {
  id: string;
  type: string;
  data: any;
}

interface Section {
  question: string;
  steps: string[];
  image?: string;
}

@Component({
  selector: 'app-document-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-page.component.html',
  styleUrl: './document-page.component.scss',
})
export class DocumentPageComponent {
  @Input() selectedDoc: any;
  @Output() back = new EventEmitter<void>();

  activeSectionIndex = 0;
  contentSections: Section[] = [];

  get blocks(): DocBlock[] {
    return this.selectedDoc?.docData?.blocks || [];
  }

  get firstHeader(): DocBlock | undefined {
    return this.blocks.find(b => b.type === 'header');
  }

  get firstParagraph(): DocBlock | undefined {
    return this.blocks.find(b => b.type === 'paragraph');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedDoc'] && this.selectedDoc) {
      this.buildContentSections();
    }
  }

  goBack() {
    this.back.emit();
  }

  setActiveSection(index: number) {
    this.activeSectionIndex = index;
  }

  /**
   * 🧠 Build structured Q&A sections
   */
  private buildContentSections() {
    this.contentSections = [];
    const blocks = this.blocks;

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];

      if (block.type === 'list' && block.data.style === 'unordered') {
        const question = block.data.items?.[0]?.content || '';
        const section: Section = { question, steps: [], image: undefined };

        // find ordered list right after unordered
        const nextBlock = blocks[i + 1];
        if (nextBlock && nextBlock.type === 'list' && nextBlock.data.style === 'ordered') {
          section.steps = nextBlock.data.items.map((item: any) => item.content);
        }

        // find image after ordered list
        const afterOrdered = blocks[i + 2];
        if (afterOrdered && afterOrdered.type === 'image') {
          section.image = afterOrdered.data.file?.url;
        }

        this.contentSections.push(section);
      }
    }
  }
}
